import React from 'react';

import Card from '../../card/card';
import ListWrapper from './list-wrapper';

export default class CardList extends React.Component {

    render() {
        const { card, match, links } = this.props;
        const { cards = [] } = card;
        return (
            <ListWrapper
                {...card} links={links}
            >
                <div className='class-resources-wrapper'>
                    {cards
                        .map((card) => (
                            <Card
                                card={card}
                                key={card.id}
                                url={match.url}
                                eadEndDate={this.props.eadEndDate}
                            />
                        ))}
                </div>
            </ListWrapper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/section/components/card-list.js